import { createFileRoute } from '@tanstack/react-router';
import { SearchPage } from '../../features/search/search-page.tsx';
import { validateSiteSearch } from '../../features/search/search-params.ts';
import { guardSection } from '../../shell/guard.ts';

// Portal search (T35). ?q= is the query; ?page= pages the results.
export const Route = createFileRoute('/_authed/search')({
  beforeLoad: guardSection('/search'),
  validateSearch: validateSiteSearch,
  component: SearchRoute,
});

function SearchRoute(): React.JSX.Element {
  const search = Route.useSearch();
  // A new query starts a fresh form, so the box always shows what the results are for.
  return <SearchPage key={search.q ?? ''} search={search} />;
}
